import { render, staticRenderFns } from "./outbox.vue?vue&type=template&id=f9e7b672&scoped=true&lang=html&"
import script from "./outbox.vue?vue&type=script&lang=js&"
export * from "./outbox.vue?vue&type=script&lang=js&"
import style0 from "./outbox.vue?vue&type=style&index=0&id=f9e7b672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e7b672",
  null
  
)

component.options.__file = "outbox.vue"
export default component.exports